import styled from 'styled-components';

const StyledLinkLabel = styled.div`
  cursor: pointer;
  align-self: baseline;
  font-size: 16px;
  text-decoration: underline;
`;

export default StyledLinkLabel;
